module.exports = __webpack_public_path__ + "img/1317416071.bf3e78e2.jpg";